import { render } from "./AssessmentPayHistory.vue?vue&type=template&id=f20e8162&scoped=true"
import script from "./AssessmentPayHistory.vue?vue&type=script&lang=js"
export * from "./AssessmentPayHistory.vue?vue&type=script&lang=js"

import "./AssessmentPayHistory.vue?vue&type=style&index=0&id=f20e8162&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f20e8162"]])

export default __exports__